import PropTypes from 'prop-types'

import { getPage } from '../../api/bantrab'

import BodySpecilizations from '../../components/bantrab/specializations'

import Header from '../../components/bantrab/specializations/listing/header'
import Benefits from '../../components/bantrab/specializations/listing/benefits'
// import Specializations from '../../components/bantrab/specializations/listing/specializations'
import Certification from '../../components/bantrab/specializations/listing/certification'
import FAQs from '../../components/bantrab/specializations/listing/faqs'
import Breadcrumb from '../../components/bantrab/specializations/listing/breadcrumb'

import { getBaseViewInfo } from '../../components/bantrab/view/functions'
import View from '../../components/bantrab/view'

const INDEX_TYPE = 'specializations.SpecializationsIndexPage'

async function getServerSideProps() {
  const { head, navbar, footer, raw } = await getBaseViewInfo()

  const indexPages = raw.rootChildrenPages.items.filter(page => page.meta.type === INDEX_TYPE)
  const indexPageId = indexPages[0].id

  let indexPage = await getPage(
    indexPageId,
    {
      fields: '*,featured_specializations(specialization(*,attachment(*),specialization_categories(*),courses(course(*,preview_video(*)))))'
    }
  )
  indexPage = await indexPage.json()

  const { featuredSpecializations: specializations } = indexPage

  const featuredSpecializations = specializations.map(({ specialization }) => specialization)

  const body = [
    {
      type: 'header',
      value: {
        title: indexPage.headerTitle,
        titleHighlightedText: indexPage.headerTitleHighlightedText,
        text: indexPage.headerText,
        image: indexPage.headerImage
      }
    },
    {
      type: 'benefits',
      value: {
        benefits: indexPage.benefitList
      }
    },
    {
      type: 'specializations',
      value: {
        featuredSpecializations
      }
    },
    /*
    {
      type: 'new-specializations',
      value: {
        specializations: featuredSpecializations
      }
    },
    */
    {
      type: 'certification',
      value: {}
    },
    {
      type: 'faqs',
      value: {
        title: indexPage.faqTitle,
        items: indexPage.faqList
      }
    }
  ]

  return {
    props: {
      head,
      navbar,
      body,
      footer,
      integrationSettings: raw.siteInfo.crehanaintegrationsettings
    }
  }
}

const SpecializationListView = ({ head, navbar, body, footer, integrationSettings }) => {
  return <View
    {...{ head, navbar, footer }}>
    {
      body.map((section, index) => {
        if (section.type === 'header') {
          return <Header
            key={index}
            id={index}
            order={index}
            {...section.value} />
        }

        if (section.type === 'benefits') {
          return <Benefits
            key={index}
            id={index}
            order={index}
            {...section.value} />
        }

        if (section.type === 'specializations') {
          return <BodySpecilizations
            key={index}
            id={index}
            order={index}
            integrationSettings={integrationSettings}
            {...section.value}
          />
        }

        /*
        if (section.type === 'new-specializations') {
          return <Specializations
            key={index}
            id={index}
            order={index}
            {...section.value}
          />
        }
        */

        if (section.type === 'certification') {
          return <Certification
            key={index}
            id={index}
            order={index}
          />
        }

        if (section.type === 'faqs') {
          return <FAQs
            key={index}
            id={index}
            order={index}
            {...section.value}
          />
        }

        return null
      })
    }
    <Breadcrumb />
  </View>
}

SpecializationListView.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.array,
  footer: PropTypes.object,
  integrationSettings: PropTypes.object
}

export { getServerSideProps }

export default SpecializationListView
